const formatDate = (dateString: string) => {
  const date = new Date(dateString);

  // Convert to Italy Time (CET/CEST)
  const options: Intl.DateTimeFormatOptions = {
    timeZone: "Europe/Rome",
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false, // 24-hour format
  };

  // Format date in Italian timezone
  const italyDate = new Intl.DateTimeFormat("en-GB", options).formatToParts(date);
  
  // Extract date parts
  let day = "";
  let month = "";
  let year = "";
  let hours = "";
  let minutes = "";

  italyDate.forEach(({ type, value }) => {
    if (type === "day") day = value;
    if (type === "month") month = value;
    if (type === "year") year = value;
    if (type === "hour") hours = value;
    if (type === "minute") minutes = value;
  });

  // Add the correct suffix for the day (st, nd, rd, th)
  const daySuffix =
    day === "1" || day === "21" || day === "31"
      ? "st"
      : day === "2" || day === "22"
      ? "nd"
      : day === "3" || day === "23"
      ? "rd"
      : "th";

  return `${day}${daySuffix} ${month} ${year} ${hours}:${minutes}`;
};


const formatDateToReadable = (isoString: string): string => {
  console.log("Time formating ", isoString);
  const date = new Date(isoString);

  const options: Intl.DateTimeFormatOptions = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "2-digit",
  };

  const formattedDate = new Intl.DateTimeFormat("en-US", options).format(date);

  return formattedDate;
};

const formatDateTimeReadable = (dateString: string) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" });
  const hours = date.getHours() % 12 || 12;
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = date.getHours() >= 12 ? "PM" : "AM";

  return `${day} ${month}, ${hours}:${minutes}${ampm}`;
};

const formatOnlyDate = (dateString: string) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" }).toUpperCase();
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};

const formatOnlyTime = (dateString: string) => {
  const date = new Date(dateString);
  const hours = String(date.getHours() % 12 || 12).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${hours}:${minutes}`;
};

const formatToISODate = (dateString: string): string => {
  const date = new Date(dateString);

  const year = date.getFullYear(); 
  const month = String(date.getMonth() + 1).padStart(2, "0"); 
  const day = String(date.getDate()).padStart(2, "0"); 

  return `${year}-${month}-${day}`;
};

export { formatDate, formatDateToReadable, formatDateTimeReadable, formatOnlyDate, formatOnlyTime, formatToISODate };
